import { render } from "./admin-lists.vue?vue&type=template&id=618539cf&scoped=true"
import script from "./admin-lists.vue?vue&type=script&lang=js"
export * from "./admin-lists.vue?vue&type=script&lang=js"

import "./admin-lists.vue?vue&type=style&index=0&id=618539cf&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618539cf"]])

export default __exports__